import React from "react";

import Quiz from "./Quiz";
import Accordion from "./Accordion";

import { BackgroundColor } from "./StyledComponents/BackgroundStyle.style";
import PictureHover from "./asset/pictures/tropical_junglee.jpg";

const Contact = () => {
  return (
    <>
      <BackgroundColor backgroundImg={PictureHover}>
        <Accordion
          title="CONTACT - CONTACT - CONTACT - CONTACT - CONTACT - CONTACT -
                  CONTACT - CONTACT - CONTACT"
          directionOfAnimation="translateLeft"
        >
          <Quiz />
        </Accordion>
      </BackgroundColor>
    </>
  );
};

export default Contact;
